<div class="row" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" class="custom-loader"></mat-progress-bar>
</div>

<div class="container-fluid mb-5">

  <div class="dashboard-card shadow-sm">

    <div class="card-header d-flex align-items-center py-3 px-4">
      <div class="icon-box mr-3">
        <mat-icon>{{ getIconByType() }}</mat-icon>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-dark-purple">{{ question?.question }}</h5>
        <small class="text-muted" *ngIf="question?.typology">
          {{ question?.typology | titlecase }} Analysis
        </small>
      </div>
    </div>

    <div class="card-body px-4 pb-4 pt-2">

      <div *ngIf="question?.description" class="description-box my-4 p-3 rounded">
        <div class="d-flex align-items-center mb-2">
          <mat-icon class="small-icon mr-2 text-primary-purple">info</mat-icon>
          <span class="text-uppercase small font-weight-bold text-primary-purple tracking-wide">
            {{ "generic.description" | translate }}
          </span>
        </div>
        <p class="formatted text-dark mb-0 pl-1">{{ question?.description }}</p>
      </div>

      <ng-container *ngIf="timelineIsDisabled; else chartBlock">
        <div class="container my-3">
          <p class="text-center text-muted">Timeline view disabled for this question type.</p>
        </div>
      </ng-container>

      <ng-template #chartBlock>
        <div class="chart-section mt-4">

          <div class="d-flex justify-content-between align-items-end mb-3">
            <div>
              <h6 class="text-uppercase text-muted letter-spacing-2 mb-1">Trends</h6>
              <h3 class="mb-0 font-weight-bold text-dark">Data Analysis</h3>
            </div>

            <div class="d-flex align-items-center">

              <ng-container *ngIf="currentChartType === 'line'">
                <mat-button-toggle-group
                  [value]="isSmooth"
                  (change)="setSmooth($event.value)"
                  class="custom-purple-toggle mr-3 shadow-sm">
                  <mat-button-toggle [value]="true" matTooltip="Smooth Lines">
                    <mat-icon>gesture</mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle [value]="false" matTooltip="Straight Lines">
                    <mat-icon>linear_scale</mat-icon>
                  </mat-button-toggle>
                </mat-button-toggle-group>

                <div class="border-left h-100 mx-1" style="height: 36px; border-color: #e0e0e0;"></div>
              </ng-container>

              <div class="d-flex flex-column align-items-end">
                <mat-button-toggle-group
                  name="chartType"
                  [value]="currentChartType"
                  (change)="setChartType($event.value)"
                  class="custom-purple-toggle shadow-sm">
                  <mat-button-toggle value="line" matTooltip="Line Chart">
                    <mat-icon>show_chart</mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle value="bar" matTooltip="Bar Chart">
                    <mat-icon>bar_chart</mat-icon>
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>

            </div>
          </div>

          <div class="chart-container rounded p-1">
            <div
              echarts
              [options]="chartOptions"
              (chartClick)="onChartClick($event)"
              class="w-100 demo-chart"
              [style.height.px]="400">
            </div>
          </div>

        </div>
      </ng-template>
<!--
      <div class="mt-5 pt-4 border-top">
        <h6 class="text-uppercase text-muted letter-spacing-2 mb-3">History Flow</h6>
        <div #mermaid class="mermaid-container d-flex justify-content-center"></div>
      </div>-->

    </div>
  </div>
</div>
